<template>
    <v-row>
        <v-col v-if="useEvents" cols="12" md="3">
            <v-select
                v-model="selectedEvent"
                :items="filterSelect"
                item-text="name"
                item-value="id"
                :disabled="isLoading"
                :label="eventsLabel"
                outlined
                dense
                hide-details
                @change="eventChange"
            ></v-select>
        </v-col>
        <v-col cols="12" :md="useEvents ? 3 : 6">
            <v-text-field
                v-if="!hideSearch"
                v-model="searchTerm"
                label="Search"
                placeholder="Search..."
                outlined
                clearable
                dense
                hide-details
                :disabled="isLoading"
                prepend-inner-icon="mdi-magnify"
                @change="filterChange"
            ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
            <v-select
                v-model="selectedTeam"
                :items="teams"
                :disabled="isLoading || teams.length === 0"
                :label="teamsLabel"
                outlined
                dense
                clearable
                hide-details
                @change="filterChange"
            ></v-select>
        </v-col>
        <v-col cols="12" md="3">
            <v-select
                v-if="!hideStatus"
                v-model="selectedStatus"
                :items="statuses"
                :disabled="isLoading"
                label="Statuses"
                outlined
                dense
                clearable
                hide-details
                @change="filterChange"
            ></v-select>
        </v-col>
    </v-row>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
export default {
    props: {
        isLoading: {
            type: Boolean,
            required: true,
        },
        useEvents: {
            type: Boolean,
            required: true,
        },
        eventsLabel: {
            type: String,
            required: false,
            default: 'Events',
        },
        eventsValues: {
            type: Array,
            required: false,
            default: () => [],
        },
        selectAllEvents: {
            type: Boolean,
            required: false,
            default: false,
        },
        teams: {
            type: Array,
            required: true,
        },
        hideStatus: {
            type: Boolean,
            required: false,
            default: false,
        },
        hideSearch: {
            type: Boolean,
            required: false,
            default: false,
        },
        startWithDefaultTeam: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            statuses: [
                { value: null, text: 'All' },
                { value: '0', text: 'Editing' },
                { value: '1', text: 'Submitted' },
                { value: '2', text: 'Flagged' },
                { value: '3', text: 'Approved' },
            ],
            selectedStatus: null,
            selectedTeam: 0,
            searchTerm: null,
            selectedEvent: null,
        }
    },
    mounted() {
        if (this.currentEvent) {
            this.selectedEvent = this.currentEvent
        }
    },
    watch: {
        currentEvent() {
            this.selectedEvent = this.currentEvent
        },
        teams() {
            this.setDefaultTeam()
        },
    },
    computed: {
        ...mapState(['user']),
        ...mapGetters(['events', 'nextEvent', 'currentEvent']),
        filterSelect() {
            let selectValues = []
            if (this.selectAllEvents) {
                selectValues.push({
                    name: 'All',
                    id: 'ALL',
                })
            }
            return selectValues.concat(
                this.eventsValues && this.eventsValues.length > 0 ? this.eventsValues : this.events,
            )
        },
        teamsLabel() {
            return this.teams.length === 0 ? 'No Teams' : 'Teams'
        },
        userDefaultTeamId() {
            if (this.user && this.user.defaultTeam) {
                let teamId = parseInt(this.user.defaultTeam)
                if (!isNaN(teamId)) return teamId
            }
            return -1
        },
    },
    methods: {
        filterChange() {
            const { selectedEvent, selectedStatus, selectedTeam, searchTerm } = this
            const filterState = { selectedEvent, selectedStatus, selectedTeam, searchTerm }
            this.$emit('change', filterState)
        },
        eventChange() {
            this.selectedStatus = null
            this.filterChange()
            if (this.eventsValues && this.eventsValues.length > 0) {
                return
            }
            this.$store.commit('setCurrentEvent', this.selectedEvent)
        },
        setDefaultTeam() {
            if (this.startWithDefaultTeam && this.userDefaultTeamId > 0) {
                if (this.teams.find(x => x.value === this.userDefaultTeamId)) {
                    this.selectedTeam = this.userDefaultTeamId
                    this.filterChange()
                }
            }
        },
    },
}
</script>
